import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import IndoMsgBox from '@/components/IndoMsgBox.vue'
import router from "./router";

import "./css/main.css";

// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;
// Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.component('indo-msgbox', IndoMsgBox)

new Vue({
  store,
  vuetify,
  axios,
  router,
  render: (h) => h(App),
}).$mount("#app");
